import React from 'react'
import PropTypes from 'prop-types'
import { Icon, Tooltip } from 'src/components'
import { Columns } from 'src/components/layout'
import { mergeProps } from '../../../../util'
import styles from './NavbarItem.scss'

/**
 * An item for the Navbar that acts as a button by default (use the `as` prop to render another wrapper).
 */
const NavbarItem = ({ as: Wrapper, icon, label, leftLabel, loading, tooltip, tooltipPlacement, ...domProps }) => (
  <Tooltip className={styles.tooltip} title={tooltip} disabled={!tooltip} popperProps={{ placement: tooltipPlacement }}>
    <Wrapper {...mergeProps()({ className: styles.wrapper }, domProps)}>
      <Columns layout="auto" gap=".25rem" align="center" className={styles.navbarItem}>
        {leftLabel && <span className={styles.label}>{leftLabel}</span>}
        <Icon icon={icon} loading={loading} fixedWidth />
        {label && <span className={styles.label}>{label}</span>}
      </Columns>
      <span className={styles.bar} />
    </Wrapper>
  </Tooltip>
)

NavbarItem.defaultProps = {
  as: 'button',
}

NavbarItem.propTypes = {
  /**
   * The navbar item wrapper.
   */
  as: PropTypes.elementType,
  /**
   * Icon displayed at the left of the item
   */
  icon: PropTypes.elementType,
  /**
   * Label displayed at the right of the item
   */
  label: PropTypes.node,
  /**
   * Label displayed at the left of the item
   */
  leftLabel: PropTypes.node,
  /**
   * Whether the item is loading or not.
   */
  loading: PropTypes.bool,
  /**
   * Tooltip to display on hover.
   */
  tooltip: PropTypes.node,
  /**
   * Tooltip placement.
   */
  tooltipPlacement: PropTypes.string,
}

export default NavbarItem
